var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareOut = function SvgIconArrowSquareOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.957 3.043a1 1 0 0 1 .293.698v5.634a1 1 0 1 1-2 0v-3.21l-5.043 5.042a1 1 0 0 1-1.414-1.414l5.043-5.043h-3.211a1 1 0 1 1 0-2h5.625l.048.001c.24.012.476.109.66.292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.75H4.75v11.5h11.5V13.5a1 1 0 1 1 2 0v6a1.75 1.75 0 0 1-1.75 1.75h-12a1.75 1.75 0 0 1-1.75-1.75v-12A1.75 1.75 0 0 1 4.5 5.75h6a1 1 0 1 1 0 2"
  }))));
};
export default SvgIconArrowSquareOut;